export default{
  user: (state) => state.user
}



// WEBPACK FOOTER //
// ./src/components/user/store/getters.js